import { BaseService } from './base';
import { ApiRequest } from '../lib/request';
import type { ApiResponse, ApiListResponse } from '../lib/response';

import { CalendarFeed } from '../models/calendarFeed';

export class CalendarFeedService extends BaseService<CalendarFeed> {
  override model = CalendarFeed;
  override modelName = 'calendarFeed';
  override modelLabel = 'Calendar Feed';

  async create({
    type,
    name,
    idEmployee,
  }: {
    type: string;
    name: string;
    idEmployee?: number;
  }): Promise<ApiResponse<CalendarFeed>> {
    const request = new ApiRequest({
      method: 'POST',
      url: `${this.modelBaseUrl}/${type}`,
      data: { name, idEmployee },
    });

    return await this.requestItem(request, CalendarFeed);
  }

  override async delete(
    feed: CalendarFeed,
  ): Promise<ApiResponse<CalendarFeed>> {
    const request = new ApiRequest({
      method: 'DELETE',
      url: `${this.modelBaseUrl}/${feed.type}/${feed.objectID()}`,
    });

    return await this.requestItem(request, CalendarFeed);
  }

  async location(
    page: number = 1,
  ): Promise<ApiListResponse<CalendarFeed>> {
    const request = new ApiRequest({
      method: 'GET',
      url: `${this.modelBaseUrl}/location`,
      query: { page: page.toString() },
    });

    return await this.requestList(request, CalendarFeed);
  }

  async employee(
    page: number = 1,
  ): Promise<ApiListResponse<CalendarFeed>> {
    const request = new ApiRequest({
      method: 'GET',
      url: `${this.modelBaseUrl}/employee`,
      query: { page: page.toString() },
    });

    return await this.requestList(request, CalendarFeed);
  }
}
